import {
  ReferenceImageMaster,
  ReferenceImageMasterCreateRequest,
  ReferenceImageMasterCreateRequestToJSON,
  ReferenceImageMasterFromJSON,
  ReferenceImageMasterUpdateRequest,
  ReferenceImageMasterUpdateRequestToJSON,
  ReferenceImageMasterUploadResponse,
  ReferenceImageMasterUploadResponseFromJSON
} from '@/api/models'
import * as runtime from '../runtime'
import { HTTPHeaders } from '../runtime'

export interface GetReferenceImageMasterByIdRequest {
  id: number
}

export interface RemoveReferenceImageMasterByIdRequest {
  id: number
}

export interface UploadReferenceImageMasterRequest {
  data: FormData
}

export interface CreateReferenceImageMasterRequest {
  referenceImageMasterCreateRequest: ReferenceImageMasterCreateRequest
}

export interface UpdateReferenceImageMasterRequest {
  referenceImageMasterUpdateRequest: ReferenceImageMasterUpdateRequest
}

export class ReferenceImageMasterApi extends runtime.BaseAPI {
  async getAllReferenceImageMaster(): Promise<ReferenceImageMaster[]> {
    const response = await this.requestGet(`/reference-image-masters`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReferenceImageMasterFromJSON)
    ).value()
  }

  /**
   * レファレンスIDによりレファレンスを取得する
   * レファレンス取得
   */
  async getReferenceImageMasterById(
    requestParameters: GetReferenceImageMasterByIdRequest
  ): Promise<ReferenceImageMaster> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling getReferenceById.'
      )
    }

    const response = await this.requestGet(
      `/reference-image-masters/${requestParameters.id}`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ReferenceImageMasterFromJSON(jsonValue)
    ).value()
  }

  async upload(
    requestParameters: UploadReferenceImageMasterRequest
  ): Promise<ReferenceImageMasterUploadResponse> {
    const headerParameters: HTTPHeaders = {}
    const response = await this.request({
      path: `/reference-image-masters/upload`,
      method: 'POST',
      headers: headerParameters,
      body: requestParameters.data
    })

    return new runtime.JSONApiResponse(response, jsonValue =>
      ReferenceImageMasterUploadResponseFromJSON(jsonValue)
    ).value()
  }

  async create(
    requestParameters: CreateReferenceImageMasterRequest
  ): Promise<ReferenceImageMaster> {
    const bodyParameters: runtime.HTTPBody = ReferenceImageMasterCreateRequestToJSON(
      requestParameters.referenceImageMasterCreateRequest
    )

    const response = await this.requestPost(
      `/reference-image-masters`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ReferenceImageMasterFromJSON(jsonValue)
    ).value()
  }

  async update(
    requestParameters: UpdateReferenceImageMasterRequest
  ): Promise<ReferenceImageMaster> {
    const bodyParameters: runtime.HTTPBody = ReferenceImageMasterUpdateRequestToJSON(
      requestParameters.referenceImageMasterUpdateRequest
    )

    const response = await this.requestPut(
      `/reference-image-masters/${requestParameters.referenceImageMasterUpdateRequest.id}`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ReferenceImageMasterFromJSON(jsonValue)
    ).value()
  }

  async remove(
    requestParameters: RemoveReferenceImageMasterByIdRequest
  ): Promise<void> {
    const response = await this.requestDelete(
      `/reference-image-masters/${requestParameters.id}`
    )

    return new runtime.VoidApiResponse(response).value()
  }
}
